'use client'

import { useState } from "react"
import { useSelector } from "react-redux"
import { Pattern1, Pattern2 } from "@/(front-desk)/utils/patterns"
import { MinusCircleIcon, PlusCircleIcon } from "@heroicons/react/24/outline"
import classNames from "classnames"

export default function faq() {

    const [ activeSection, setActiveSection ] = useState([])
    const CMS = useSelector((state) => state.CMS)
    const faqList = {
        "individual": {
            pattern: <Pattern2 className="w-[5rem] fill-[#EAF295]" />,
            name: '獨立展區',
            list: [
                {
                    question: '我們會有超過十組同學共同參展，需要自己佈建參展場地，請問能提供多大的場地給我們呢？',
                    answer: '大會提供 6*6㎡、6*12㎡、9*9㎡ 三種攤位大小規格選擇。其他大小需求請於提案書中說明，審查委員將「依企劃內容、實際展出作品件數」等評估。'
                },
                {
                    question: '我們目前還不確定要以何種展區型態參展，但截止時間快到了，請問我可以先交企劃書，之後再修改嗎？',
                    answer: '不行，攤位申請時務必確認獨立/聯合展區兩者之規格限制及佈展差異，提交企劃書後「不得修改」申請身份。'
                },
                {
                    question: '因為需要估算插座需求量，想確認一下二次配電中，一座插座會提供幾個插孔使用呢？',
                    answer: '大會二次配電施作的插座規格：每個標記插座點位提供 2 副「三孔插座」。（請使用正面的兩個三孔插座、側邊兩孔插座切勿自行使用）'
                },
                {
                    question: '獨立展區本次繳交的展場整體規劃書，繳交後後續展場設計是否還能進行修改調整?',
                    answer: `若後續展區規劃有大幅度的變動，須「主動提交更新企劃書」並告知大會（電郵：${CMS.registries['cms.home.footer.email']}），最終展區配置審核將依大會收到最新企劃書為依據。`
                },
                {
                    question: '承上，獨立展區的更新企劃書最後繳交期限是何時?',
                    answer: '與參展申請-第三階段作業-繳交攤位配電及地毯申請資料同一時限（2024/3/29 前繳交），因配電資料繳交後就不能再做調整，故展攤配置基本上也不再有大調動。若超過時限尚有攤位異動將依高展館規範追加作業金。'
                },
            ]
        },
        "group": {
            pattern: <Pattern1 className="w-[5rem] fill-[#8DE4EC]" />,
            name: '聯合展區',
            list: [
                {
                    question: '請問聯合展區的攤位需求怎麼計算？',
                    answer: '聯合展區一單位為「9」平方公尺（3m*3m），也就是長寬估算各「3」米；申請的大小必須為「9」的倍數。'
                },
                {
                    question: '我們有超過四組同學想要一起參展，可以用聯合展區方式參展嗎？聯合展區攤位多大？各個攤位內的空間配置如何呢？',
                    answer: '不建議，聯合展區可申請攤位數為 1-4 組，每組 3m*3m，每攤位場域內建議展示作品數「至多 4 組」，每攤位提供展桌*1（聯合展區展桌約 3*1m），可用桌面空間約 90cm*60cm，請依實際展出作品型態評估需求攤位數。每 3m*3m 會以開放式結構進行隔間，避免視線及空間過於狹隘封閉。'
                },
                {
                    question: '我們有報名聯合展區，請問攤位費中有包含那些照明及電力設備呢？',
                    answer: '團體參展單位：攤位照明規格為 10W 長柄投光燈 *3 盞 +15A 插座一組（共兩孔）；可自備延長線分接，但設備總用電不能超過 1500W。'
                },
                {
                    question: '請問團體展聯合展區企劃書中的展示設計構想與策略只要提供文字說明即可、不需出空間配置圖？',
                    answer: '是，內容可依照實際內容進行調整說明，但不影響攤位佈建之架構'
                },
                {
                    question: '若於聯合展區申請 3*6 的攤位尺寸，中間會有隔牆嗎？',
                    answer: '目前設定每 3*3 中間會有隔板，傾向於攤位兩面皆有開口。同一申請單位，會集中設置，但實際攤位長寬配置以大會評核結果為主。'
                },
                {
                    question: '聯合展區規定不能張貼輸出物，是指只有架構，沒有牆面嗎？',
                    answer: '聯合展區較明確之展攤設計預計於明年初公告，請先以可移動式輸出物為優先考量。如有牆面可供張貼，屆時會公告規格，但輸出須由各單位自行負擔且牆面不能有殘膠、損壞痕跡否廠商將照價賠償。'
                },
                {
                    question: '聯合展區附的櫃子可以拆裝或黏貼輸出物嗎？',
                    answer: '不可拆裝，請維持結構完整性，但可以不殘膠方式黏貼輸出物。'
                },
                {
                    question: '聯合展區牆面的組合板是黑色的嗎？',
                    answer: '尚未確認，預計明年初會有更明確之攤位設定。'
                },
            ]
        },
        "booth": {
            pattern: <Pattern2 className="w-[5rem] fill-[#EAF295]" />,
            name: '個人攤位',
            list: [
                {
                    question: '我想要展出自己的個人作品，請問可以個人展區名義報名嗎？',
                    answer: '今年並「無」個人展區之規劃，惟有確認「入圍決選、但校系尚無展區之團隊」能夠開放追加申請。'
                },
                {
                    question: '參展說明中有個人決選攤位欄位，請問這個是跟聯合展區的申請時間一樣嗎？',
                    answer: '競賽於 5/13（一） 公布決選入圍名單，同步開放「個人決選攤位」申請，入決選之團隊請留意後續階段作業流程與時限。'
                },
                {
                    question: '請問個人決選攤位會提供的電力設備包含哪些呢？',
                    answer: '個人決選攤位：插座規格為一組 5A（共兩孔）；可自備延長線分接，但設備總用電不能超過 500W。'
                },
            ]
        },
        "entry": {
            pattern: <Pattern1 className="w-[5rem] fill-[#8DE4EC]" />,
            name: '進場相關',
            list: [
                {
                    question: '我們的作品會提前寄到，能請你們先幫忙簽收並暫放嗎？',
                    answer: '倉儲問題：大會「無」提供包裹代收/寄物服務。'
                },
                {
                    question: '我好像漏帶一個設備了，請問可以跟主辦單位租借嗎？',
                    answer: '大會「無」提供設備、器具借用服務。'
                },
                {
                    question: '展區位置真的不夠放，請問我可以把東西稍微挪到走道上嗎？',
                    answer: '走道應保持淨空，無論攤位物品、行李等任何物品均不能堆放。'
                },
                {
                    question: '我的朋友要進來參觀放視大賞，除了從成功路上的東門出入口外，還可以從哪邊進出呢？',
                    answer: '南館 S2 出入口今年也將開放。'
                },
                {
                    question: '我們很關心施工人員及作品的安全，請問進場及活動期間，主辦單位會有相關的保險嗎？',
                    answer: '針對同學在展區布置、裝潢及展期間活動的安全保險，請參照展覽作業須知 P14-P15 內容，進場-保險之說明。大會會投保展期三日的公共意外險，但各參展單位還是須就參展人員、展品等自行投保相關責任險。'
                },
            ]
        },
        "register": {
            pattern: <Pattern2 className="w-[5rem] fill-[#EAF295]" />,
            name: '報名相關',
            list: [
                {
                    question: '請問只要資料都上傳即可，不用另外在確認繳交之類的按鈕對嗎？',
                    answer: '是的，只要都上傳即可，接下來只需要等待審核通過。'
                },
                {
                    question: '參展保證金是否可以用臨櫃匯款之外的方式繳納？',
                    answer: '可以，請參照展覽作業須知 _P.40_ 附件 5 之備註說明。只要繳款明細可清楚顯示帳戶/金額資訊以便查帳即可。'
                },
                {
                    question: '原訂參展的內容，若有類別和件數有異動，需要提繳異動申請單嗎？',
                    answer: '請先知會主辦單位（LINE 社群、致電或郵件）異動內容，若是異動幅度較小者，無須提供申請和企劃書；但若是大幅修改展區設計者，請再提供異動申請和更新企劃書。'
                },
                {
                    question: '請問策展企劃書是否會有第二次收件？',
                    answer: '企劃書主要只會有一次收件，後續僅針對有大幅展區異動的的展區，開放企劃書更新'
                },
                {
                    question: '明年 3/18 的策展籌備會議是線上舉行嗎？還是場勘的同時一同在展覽現場舉辦？',
                    answer: '策展籌備會議屆時會實體辦理，並辦理場勘事宜。會議在高軟園區舉行，場勘在展覽館，屆時會帶領大家步行前往，兩地在隔壁而已。'
                },
            ]
        }
    }

    return (
        <>
        <title>常見問題 - 放視大賞</title>
        <main id="main" className="faq">
            <div className="page-banner mb-8">
                <div className="page-banner-content">
                    <h1 className="title">FAQ</h1>
                    <h2 className="sub-title">常見問題</h2>
                </div>
            </div>
            { Object.keys(faqList).map((type) => {
                const questionArea = 
                    <div key={`question-${type}`} className="question-area">
                        { faqList[type].pattern }
                        <div className="title">{faqList[type].name}</div>
                        { faqList[type].list.map((e) => {
                            const handleActiveSection = () => {
                                if (activeSection.indexOf(`${type}-${e.question}`) === -1) {
                                    setActiveSection(activeSection => [
                                        ...activeSection, `${type}-${e.question}`
                                    ])
                                }
                                else {
                                    setActiveSection(activeSection.filter((section) => { 
                                        return section !== `${type}-${e.question}`
                                    }))
                                }
                            }
                            const section = 
                                <div
                                    key={`${type}-${e.question}`}
                                    className={classNames('section', {
                                        'active': activeSection.includes(`${type}-${e.question}`)
                                    })}
                                    onClick={handleActiveSection}
                                >
                                    <div className="question">
                                        <div className="text">
                                            {e.question}
                                        </div>
                                        <MinusCircleIcon />
                                        <PlusCircleIcon />
                                    </div>
                                    <div className="answer prose" dangerouslySetInnerHTML={{__html: e.answer}}></div>
                                </div>
                                return section
                        })}
                    </div>
                return questionArea
            })}
        </main>
        </>
    )
}